module.exports = __webpack_public_path__ + "static/media/nagihanYuksek.bcefb936.png";